<template>

        <div >
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-container
                            color="black"
                            class="hidden-sm-and-down"
                            v-bind="attrs"
                            v-on="on"
                    >
                        <v-avatar size="30" class="mx-1" color="accent">
                            <v-icon color="white">
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>
                        {{getUserName}}
                    </v-container>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn color="black"
                                   text
                                   rounded
                                   class="hidden-sm-and-down"
                                   @click="redirectToMyOrders()"
                                   >
                                Objednávky
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn color="black"
                                   text
                                   rounded
                                   class="hidden-sm-and-down"
                                   @click="redirectToMyReviews()"
                            >
                                Recenzie
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn color="black"
                                   text
                                   rounded
                                   class="hidden-sm-and-down"
                                   @click="redirectToProfile()"
                                   >
                                Profil
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-title>
                            <v-btn color="black"
                            text
                            rounded
                            class="hidden-sm-and-down"
                            @click="logout()">
                            Odhlásiť
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

</template>

<script>
    import axios from 'axios';
    import store from "../store/store";
    export default {
        name: "myAvatar",
        data: () => ({
            //isLogged : false
        }),
        methods: {
            checkIfIsLogged() {
                if(localStorage.getItem('isLogged') == 'logged'){
                    this.$router.push({name: 'userDashboard'});
                    store.commit("setLoggedUser", {
                        name:localStorage.getItem('loggedUserName'),
                        surname: localStorage.getItem('loggedUserSurname'),
                        id:localStorage.getItem('loggedUserId')
                    });
                }
                /*
                axios.get(store.state.url.concat('isLogged.php'))
                    .then((response) => {
                        if(response.data.result == 'logged'){
                            this.$router.push({name: 'userDashboard'});
                            store.commit("setLoggedUser", {
                                name:response.data.name, surname: response.data.surname, id:response.data.id
                            });
                        }
                    });*/
            },
            logout() {
                axios.get(store.state.url.concat("logout.php"))
                    .then((response) => {
                        if(response.data.result == 'ok'){
                            store.commit("logout");
                            localStorage.setItem('isLogged', 'notLogged');
                            localStorage.setItem('loggedUserName', '');
                            localStorage.setItem('loggedUserSurname', '');
                            localStorage.setItem('loggedUserId', '');
                            this.$router.push({name: 'home'});
                        }
                    });
            },
            redirectToProfile() {
                this.$router.push({name: 'profile'});
            },
            redirectToMyOrders() {
                this.$router.push({name: 'userDashboard'});
            },
            redirectToMyReviews() {
                this.$router.push({name: 'reviews'});
            },
            created() {
                this.checkIfIsLogged();
            }
        },
        computed:{
            isLogged() {
                store.state.isLogged = (localStorage.getItem('isLogged') == 'logged');
                //return localStorage.getItem('isLogged') == 'logged';
                return store.state.isLogged;
            },
            getUserName() {
                store.state.name = localStorage.getItem('loggedUserName');
                //return localStorage.getItem('loggedUserName');
                return store.state.name;
            },
            getUserSurname() {
                store.state.name = localStorage.getItem('loggedUserSurname');
                //return localStorage.getItem('loggedUserSurname');
                return store.state.surname;
            }
        }
    }
</script>

<style scoped>

</style>